import { handleActions } from 'redux-actions';
import { mobileNumberUpdateSuccess, mobileNumberUpdateError, State } from './action';

const initialState: State = {
  isSuccess: false,
  errors: {
    mobileNumber: '',
    otpCode: '',
  },
};

const reducer = handleActions(
  {
    [String(mobileNumberUpdateSuccess)]: (state) => {
      return {
        ...state,
        isSuccess: true,
        errors: initialState.errors,
      };
    },

    [String(mobileNumberUpdateError)]: (state, { payload }) => {
      return {
        ...state,
        isSuccess: false,
        errors: payload.errors,
      };
    },
  },

  initialState,
);

export default reducer;
